module.exports = __webpack_public_path__ + "static/why-oic-0be57bf55c882b2b4cd6949abb1ff6ca.jpg";